function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 2.99133C10.6719 2.23011 11.6549 1.75 12.75 1.75C14.775 1.75 16.4167 3.39162 16.4167 5.41667C16.4167 7.44171 14.775 9.08333 12.75 9.08333C11.6549 9.08333 10.6719 8.60322 10 7.842M12.75 18.25H1.75V17.3333C1.75 14.2958 4.21243 11.8333 7.25 11.8333C10.2876 11.8333 12.75 14.2958 12.75 17.3333V18.25ZM12.75 18.25H18.25V17.3333C18.25 14.2958 15.7876 11.8333 12.75 11.8333C11.7482 11.8333 10.809 12.1012 10 12.5691M10.9167 5.41667C10.9167 7.44171 9.27504 9.08333 7.25 9.08333C5.22496 9.08333 3.58333 7.44171 3.58333 5.41667C3.58333 3.39162 5.22496 1.75 7.25 1.75C9.27504 1.75 10.9167 3.39162 10.9167 5.41667Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9937dbba.svg";
export { ForwardRef as ReactComponent };